import { Col, Form, Row } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as Right } from "../../../static/arrowRight.svg";
import "./custom.scss";
const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedCustomName extends Component {
  componentDidMount() {
    this.props.openKeyboard();
  }

  submitForm = async () => {
    //await this.props.submit();
    this.props.next();
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
    };
    return (
      <div>
        <div>
          <Form
            ref={this.props.formRef}
            {...formItemLayout}
            name="email"
            onFinish={this.submitForm}
            scrollToFirstError
            layout="vertical"
            //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
          >
            <Row>
              <Col span={18} style={{ padding: "1.5em" }}>
                <Form.Item
                  //label={<strong>Név:</strong>}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Kérem adja meg a nevét!",
                    },
                  ]}
                >
                  <input
                    id="name"
                    name="name"
                    onChange={this.props.change}
                    value={this.props.name}
                    onFocus={this.props.setInputName}
                    style={{ width: "100%" }}
                    className="custom-input-field"
                    placeholder="Név"
                  />
                </Form.Item>
              </Col>
              <Col span={4} style={{ padding: "1.5em" }}>
                <Form.Item>
                  <button className="custom-next-button" type="submit">
                    Következő <Right className="custom-arrow-icon" />
                  </button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const CustomName = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedCustomName);
export default CustomName;
